import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router';

import RightColumn from 'components/RightColumn';
import Section from 'components/RightColumn/Section';
import SearchableContactList from 'components/Shared/Contacts/SearchableContactList';
import { injectIntl } from 'react-intl';
import Icon from 'components/Shared/Common/Icon';
import CatchError from 'components/CatchError';
import { CONTACT_STATUS } from 'const/user';
import SimpleSkeleton from 'components/Shared/Contacts/SimpleSkeleton';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';

const RCContactList = ({ isExpanded, toggle, intl, otherProps: { contactCount } }) => (
    <Section
        onClick={toggle}
        isExpanded={isExpanded}
        header={(
            <CategoryTitle
                label={isExpanded ? intl.formatMessage({ id: 'rightColumn.contacts.title' }) : ''}
                icon={<Icon size="xl" iconName="Users" />}
                count={contactCount}
            />
        )}
        isExpandable
    >
        <SearchableContactList 
            contactStatus={CONTACT_STATUS.ACCEPTED}
            SkeletonComponent={SimpleSkeleton}
            isExpanded={isExpanded}
        />
    </Section>
);

const settings = [{
    paths: [
        { path: '/', exact: true },
        '/dashboard'
    ],
    components: [RCContactList],
    size: 'sm',
    isExpandable: true
}, {
    paths: [
        '/profile'
    ],
    components: [RCContactList],
    size: 'sm',
    isExpandable: true
}, {
    paths: [
        '/settings'
    ],
    components: [RCContactList],
    size: 'sm',
    isExpandable: true
}, {
    paths: [
        '/activities'
    ],
    size: 'sm',
    components: [RCContactList],
    isExpandable: true
}];

const Index = ({
    currentPath,
    intl,
    contactCount = null
}) => {
    const route = settings.find(x =>
        x.paths.find((path) => {
            if (typeof path === 'object') {
                return path.exact
                    ? currentPath === path.path
                    : matchPath(currentPath, path.path);
            }
            return matchPath(currentPath, path);
        }));

    if (!route) return null;

    return (
        <CatchError>
            <RightColumn size={route.size || 'md'} isExpandable={route.isExpandable}>
                {({ isExpanded, toggle }) =>
                    route.components.map((Component, index) => (
                        <Component
                            key={index}
                            isExpanded={isExpanded}
                            toggle={toggle}
                            intl={intl}
                            otherProps={{ contactCount }}
                        />
                    ))}
            </RightColumn>
        </CatchError>
    );
};

Index.propTypes = {
    currentPath: PropTypes.string.isRequired,
    intl: PropTypes.any.isRequired,
    contactCount: PropTypes.number
};

export default memo(injectIntl(Index));
